import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './Home.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';

function Home(props: HomeProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loading, setLoading] = React.useState(true);

    const [template, setTemplate] = React.useState<any | undefined>();

    function getTemplate() {
        setLoading(true);
        axios.single({
            method: 'get',
            url: "/api/breeds/template/" + auth.selectedBreed + "/frontpage",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setTemplate(res.data);
            setLoading(false);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getTemplate();
        }
    }, [auth.selectedBreed]);

    return (
        <div className="maincontent">
            <div className={styles.home}>
                <h1>{t("overview.title")}</h1>
                <hr/>
                { !loading && template != undefined ?
                    <div dangerouslySetInnerHTML={{ __html: template.TEMPLATE}}></div>
                : null }
                { !loading && (template == undefined || template == "") ?
                    <>
                        <p>
                            <strong>Dette er en pilot for et fagsystem for avlsrådene i Norske Elghundklubbers Forbund.</strong><br/>
                            Piloten er under etablering og utprøving og har fortsatt en del mangler.
                        </p>

                        <p>
                            Pr nå ligger det inne en del data på rasene Norsk Elghund Grå, Jämthund og Norsk Elghund sort.<br/>
                            Data til piloten er hentet fra NKK, via et såkalt API.<br/>
                            Rådata oppdateres 1 gang pr uke, men avlsverdier og slektskapsverdier vil ikke oppdateres underveis i piloten.
                        </p>
                        
                        <p>
                            Pr nå har alle testbrukere tilgang til alle raser. Dette vil endres med reelle brukere.
                        </p>

                        <hr/>
                        <p>
                            Tilbakemelding/spørsmål kan rettes til <a href="mailto:marte.wetten@aninova.no">marte.wetten@aninova.no</a>. Er det krise, ring 99544702.
                        </p>

                        <p>
                            Det settes pris på om man prøver å samle tilbakemeldingene.<br/>
                            Ting vi ønsker tilbakemelding på er Funksjonalitet, feil/mangler, ønsker om ytterligere funksjoner mm. 
                        </p>
                    </>
                : null }
                { loading ?
                    <p>{t("overview.loading")}</p>
                : null }
            </div>
        </div>
    );
}

class HomeProps {
    
}

export default Home;